import './Logo.scss'

class Logo extends HTMLElement {}

customElements.define('a-logo', Logo)
